import saveAs from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
import moment from "moment";
import { LeaveView } from "./FinancialYear";
export const generateWordDocument = (appliedReport, isOldReportYear, apply) => {
  const isApril = (appliedReport?.month === 4) || isOldReportYear;
  
  
  const content = [];
  const formatDate = (date) => moment(date).format("DD-MM-yyyy");

  const createTableHeader = (headers) =>
    `
    <thead style="border-bottom: 1px solid black;">
      <tr>
          ${headers.map((header) =>
      typeof header === "string" ?
        `<th style="border: 1px solid black;">
          ${header}
        </th>`: typeof header === "object" ?
          `<th style="border: 1px solid black;">
          <table  style="border-collapse: collapse; width: 100%;">
            <tr>
              <th colspan="2" style="border: 1px solid black;">${header?.header}</th>
            </tr>
            <tr>
              <th style="border: 1px solid black;">${header?.program}</th>
              <th style="border: 1px solid black;">${header?.course}</th>
            </tr>
          </table>
        </th>`: typeof header === "boolean" && ''
    ).join("")}
      </tr>
    </thead>`;

  const createTableRow = (rowData) =>
    `<tr>
    ${rowData?.map((data) =>
      typeof data === "string" ?

        `<td style="border: 1px solid black;">
    ${data.toString()}
    </td>`: typeof data === "object" ?
          `
    <td>
    <table  style="border-collapse: collapse; width: 100%;">
        <tr>
            <td style="border: 1px solid black;">${data?.program}</td>
            <td style="border: 1px solid black;">${data?.course}</td>
        </tr>
    </table>
</td>
    `: typeof data === "boolean" && ''
    ).join("")}
    </tr>`;

  if (apply?.employee_ids?.length === 1 && apply?.employee_ids[0]?.label !== "All" || !apply?.employee_ids) {
    content.push(
      `
      <p style="text-align:center; font-weight:bold;">GENERAL INFORMATION</p>
    <table>
    <tr>
        <td>1. Name</td>
        <td>: ${appliedReport?.name}</td>
    </tr>
    <tr>
        <td>2. Date of Birth</td>
        <td>: ${moment(appliedReport?.dob).format("DD-MM-yyyy")}</td>
    </tr>
    <tr>
        <td>3. Father's Name</td>
        <td>: ${appliedReport?.father_name}</td>
    </tr>
    <tr>
        <td>4. Name of the Department / Centre / Extension Centre</td>
        <td>: ${appliedReport?.department}</td>
    </tr>
    <tr>
        <td>5. Current Designation & Scale of Pay</td>
        <td>: ${appliedReport?.designation}</td>
    </tr>
    <tr>
    <td>6. Academic Qualification obtained during the Assessment Period</td>
    <td>: ${appliedReport?.academic_qualification?.map((item, i) => (item?.qualification)).join('.,')}</td>
    </tr>
    <tr>
    <td>7. Period of absence from duty during the year (Leave)</td>
    <td>:  ${LeaveView(appliedReport?.period_of_absence)}
    </td>
    </tr>     

    `
    )
    // if (isApril) {
    //   content.push(`<tr>
    //   <td>8:  Annual Immovable Property Return the current year</td>
    //   <td>: ${appliedReport?.annual_immovable}</td>
    //   </tr>`)
    // }
    content.push(`</table>`)
  }

  {
    (appliedReport?.non_sponsored_training?.length > 0 || appliedReport?.non_sponsored_training?.length > 0 || appliedReport?.skill_development?.length > 0 || appliedReport?.development_of_moocs?.length > 0 || appliedReport?.resource_person?.length > 0 || appliedReport?.development_of_training_manual?.length > 0 || appliedReport?.courses_handled_for_pg_phd?.length > 0 || appliedReport?.new_courses_developed_offered?.length > 0 || appliedReport?.curriculum_developed_or_revised?.length > 0) &&
      content.push(`<p style="text-align:center; font-weight:bold;">ACADEMIC CONTRIBUTIONS</p>`)

  }

  if (appliedReport?.non_sponsored_training?.length > 0) {
    content.push(
      '<h4 className="reporttitle">a. Grant in aid Training Programmes to be conducted as Coordinator:</h4>'
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        isOldReportYear ? "FDP.No" : 'PDP.No',
        "Mode",
        "Conducted at",
        "Duration",
        "No.of Hours Handled",
        isOldReportYear ? "Level" : "Revenue Generated(in Rs)",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.non_sponsored_training.forEach((nonsponsored) => {
      content.push(
        createTableRow([
          nonsponsored?.fdp_no,
          nonsponsored?.mode,
          nonsponsored?.conducted_at,
          `${formatDate(nonsponsored.from_date)} - ${formatDate(
            nonsponsored.to_date
          )}`,
          nonsponsored?.no_of_hours?.toString(),
          isOldReportYear ? nonsponsored?.level : nonsponsored?.revenue_generated?.toString(),
        ])
      );
    });
    {
      !isOldReportYear &&
        content.push(`
      <tr>
        <td style="border: 1px solid black;"></td>
        <td style="border: 1px solid black;"></td>
        <td style="border: 1px solid black;"></td>
        <td style="border: 1px solid black;"></td>
        <td style="border: 1px solid black;">Total Generated Revenue</td>
        <td style="border: 1px solid black;">
          ${appliedReport?.non_sponsored_training_total_revenue}
        </td>
        <td style="border: 1px solid black;"></td>
        <td style="border: 1px solid black;"></td>
      </tr>
    `)
    }
    content.push("</tbody></table>");
  }
  if (appliedReport?.sponsored_contact_mode?.length > 0) {
    content.push(
      "<h4> b. Sponsored Contact mode Training Programmers conducted as Coordinator/ Co-coordinator (Funded by State/Central Government or ITEC) :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of the Programme",
        !isOldReportYear && "Mode",
        "Sponsoring Agency",
        "Conducted at",
        "Duration",
        "Role",
        "No.of Hours Handled",
        "Level",
        "Amount of Grant (Rs. in Lakhs)",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.sponsored_contact_mode.forEach((sponsored) => {
      content.push(
        createTableRow([
          sponsored?.title,
          !isOldReportYear && sponsored?.mode,
          sponsored?.sponsored_agency,
          sponsored?.conducted_at,
          `${formatDate(sponsored.from_date)} - ${formatDate(
            sponsored.to_date
          )}`,
          sponsored?.role,
          sponsored?.no_of_hours?.toString(),
          sponsored?.level,
          sponsored?.amount?.toString(),
          // sponsored?.attachment
          //   ? `<a href="${imagepath}${sponsored?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    ${!isOldReportYear ? `<td style="border: 1px solid black;"></td>` : ''}
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;">Total Grants Received</td>
    <td style="border: 1px solid black;">
      ${appliedReport?.total_amount_recieved_for_sponsored_contact_mode}
    </td>
   
  </tr>
    `)
    content.push("</tbody></table>");
  }
  if (appliedReport?.skill_development?.length > 0) {
    content.push(
      "<h4>c. Skill Development / Industrial Training Programmers conducted as Coordinator/ Co-coordinator :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of the Programme",
        "Sponsoring Agency",
        "Conducted at",
        "Duration",
        "Role",
        "No.of Hours Handled",
        isOldReportYear && "Level",
        "Amount of Grant (Rs. in Lakhs)",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.skill_development.forEach((skill) => {
      content.push(
        createTableRow([
          skill?.title,
          skill?.sponsored_agency,
          skill?.conducted_at,
          `${formatDate(skill.from_date)} - ${formatDate(skill.to_date)}`,
          skill?.role,
          skill?.no_of_hours?.toString(),
          isOldReportYear && skill?.level,
          skill?.amount?.toString(),
          // skill?.attachment
          //   ? `<a href="${imagepath}${skill?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    ${isOldReportYear ?
        `<td style="border: 1px solid black;"></td>` : ''
      }
    <td style="border: 1px solid black;">Total Grants Received</td>
    <td style="border: 1px solid black;">${appliedReport?.total_amount_recieved_for_skill_development}</td>
    <td style="border: 1px solid black;"></td>
  </tr>
    `);
    content.push("</tbody></table>");
  }
  if (appliedReport?.development_of_moocs?.length > 0) {
    content.push(
      "<h4> d. Development/offer of MOOCs / MMLPs as Coordinator / Co-coordinator or minimum 30 min video lectures / Educational video films :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of the MOOC / MMLP / 30 min video lectures / Educational video films",
        isOldReportYear ? "Date of Launch" : "status",
        !isOldReportYear && 'Duration',
        "Time",
        "Platform",
        "Coordinator / Co-Coordinator",
        "Used for",
      ])
    );
    content.push("<tbody>");
    appliedReport?.development_of_moocs.forEach((develop) => {
      content.push(
        createTableRow([
          develop?.title,
          isOldReportYear ? `${formatDate(develop?.date_of_launch)}` : develop?.status,
          !isOldReportYear && `${formatDate(develop?.from_date)} - ${formatDate(develop?.to_date)}`,
          develop?.time_taken,
          develop?.platform,
          develop?.coordinator_or_co_coordinator,
          develop?.used_for,
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.resource_person?.length > 0) {
    content.push(
      "<h4>e. Resource person in Training Programmes (Institute) :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        isOldReportYear ? 'FDP.No' : "Course Number",
        !isOldReportYear && 'Course Type',
        "Mode",
        "Conducted at",
        "Duration",
        "No.of Hours Handled",
        isOldReportYear && "Level",
      ])
    );
    content.push("<tbody>");
    appliedReport?.resource_person.forEach((resource) => {
      content.push(
        createTableRow([
          resource?.fdp_no,
          !isOldReportYear && resource.course_type,
          resource?.mode,
          resource?.conducted_at,
          `${formatDate(resource.from_date)} - ${formatDate(
            resource.to_date
          )}`,
          resource?.no_of_hours?.toString(),
          isOldReportYear && resource?.level,
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    ${!isOldReportYear &&
      `<td style="border: 1px solid black;"></td>`}
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;">Total Number of hours handled</td>
    <td style="border: 1px solid black;">${appliedReport?.total_no_of_hours_for_resource_person}</td>
    <td style="border: 1px solid black;"></td>
  </tr
    `);
    content.push("</tbody></table>");
  }
  if (appliedReport?.development_of_training_manual?.length > 0) {
    content.push(
      "<h4> f. Development of Training / Laboratory Manuals:</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Author (s) Name in order as appeared",
        "Title",
        "Type of publications",
        "Publisher Country",
        "Publisher Year",
        "Total Pages",
      ])
    );
    content.push("<tbody>");
    appliedReport?.development_of_training_manual.forEach((development) => {
      content.push(
        createTableRow([
          development?.author_name,
          development?.title,
          development?.type_of_publications,
          development?.publisher_country,
          development?.publisher_year?.toString(),
          development?.total_pages?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.courses_handled_for_pg_phd?.length > 0) {
    content.push("<h4>g. Courses handled for PG / Ph.D. Programme :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Course Number and Title",
        "Degree",
        "Type of Subject",
        "Credit",
        !isOldReportYear && "Duration",
        isOldReportYear && "Type of College",
        "Type",
        isOldReportYear && "No.of Hours Handled",
      ])
    );
    content.push("<tbody>");
    appliedReport?.courses_handled_for_pg_phd.forEach((courses) => {
      content.push(
        createTableRow([
          courses?.course_number_and_title,
          courses?.pg_or_phd,
          courses?.theory_or_laboratory,
          courses?.credit?.toString(),
          !isOldReportYear && `${formatDate(courses.from_date)} - ${formatDate(courses.to_date)}`,
          isOldReportYear && courses?.university_or_institute,
          courses?.individual_or_shared,
          isOldReportYear && courses?.no_of_hours?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.new_courses_developed_offered?.length > 0) {
    content.push("<h4>h. New Course(s) developed and offered :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Course Number and Title",
        "Degree",
        "Type of Subject",
        "Credit",
        isOldReportYear && "Type of College",
        "Type",
        isOldReportYear ? "No.of times Offered" : "First time Offered",
      ])
    );
    content.push("<tbody>");
    appliedReport?.new_courses_developed_offered.forEach((newcourses) => {
      content.push(
        createTableRow([
          newcourses?.course_number_and_title,
          newcourses?.pg_phd_or_fdp_level,
          newcourses?.theory_or_laboratory,
          newcourses?.credit?.toString(),
          isOldReportYear && newcourses?.university_or_institute,
          newcourses?.individual_or_shared,
          isOldReportYear ? newcourses?.no_of_times?.toString() : newcourses?.first_time_offered?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.curriculum_developed_or_revised?.length > 0) {
    content.push("<h4>i. Curriculum Developed / Revised :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Role Type",
        isOldReportYear && {
          header: "Curriculam Developed",
          program: "No. of Programs",
          course: "No. of Courses",

        },
        isOldReportYear && {
          header: "Curriculam Revised",
          program: "No. of Programs",
          course: "No. of Courses",

        },
        !isOldReportYear && "Curriculam",
        !isOldReportYear && "No. of Courses",
        "Amount (Rs. in Lakhs)",
      ])
    );
    content.push("<tbody>");
    appliedReport?.curriculum_developed_or_revised.forEach((curriculam) => {
      content.push(
        createTableRow([
          curriculam?.client,
          isOldReportYear && {
            program: curriculam?.curriculum_developed?.no_of_programs,
            course: curriculam?.curriculum_developed?.no_of_courses,

          },
          isOldReportYear && {
            program: curriculam?.curriculum_revised?.no_of_programs,
            course: curriculam?.curriculum_revised?.no_of_courses,

          },
          !isOldReportYear && curriculam?.developed_or_revised,
          !isOldReportYear && curriculam?.no_of_courses,
          curriculam?.amount?.toString()
        ])
      );
    });
    content.push("</tbody></table>");
  }
  {
    (appliedReport?.phd_research_guidances?.length > 0 || appliedReport?.post_graduate_thesis_guidances?.length > 0 || appliedReport?.sponsored_research_projects?.length > 0 || appliedReport?.consultancy_works_carried_out?.length > 0 || appliedReport?.research_publications?.length > 0 || appliedReport?.papers_presentation?.length > 0 || appliedReport?.books_authored?.length > 0 || appliedReport?.patents?.length > 0 || appliedReport?.awards_details?.length > 0) &&
      content.push(`<p style="text-align:center; font-weight:bold;">RESEARCH CONTRIBUTIONS</p>`)
  }


  if (appliedReport?.phd_research_guidances?.length > 0) {
    content.push("<h4>a. Ph.D. research scholars guided :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Name of Ph.D. Students",
        "Title of thesis",
        "NITTTR / Affiliating University",
        "Year of Completion",
        "Staff",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.phd_research_guidances.forEach((apply) => {
      content.push(
        createTableRow([
          apply?.name_of_the_student,
          apply?.title,
          apply?.affiliating_university,
          apply?.year_of_completion?.toString(),
          apply?.supervisor_or_joint_supervisor,
          // apply?.attachment
          //   ? `<a href="${imagepath}${apply?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.post_graduate_thesis_guidances?.length > 0) {
    content.push("<h4> b. Post Graduate thesis guided :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Name of Ph.D. Students",
        "Title of thesis",
        "NITTTR / Affiliating University",
        "Year of Completion",
        "Staff",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.post_graduate_thesis_guidances.forEach((post) => {
      content.push(
        createTableRow([
          post?.name_of_the_student,
          post?.title,
          post?.affiliating_university,
          post?.year_of_completion?.toString(),
          post?.supervisor_or_joint_supervisor,
          // post?.attachment
          //   ? `<a href="${imagepath}${post?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.sponsored_research_projects?.length > 0) {
    content.push("<h4>c. Sponsored research projects carried out :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Project Title",
        "Sponsoring Agency",
        "Period",
        isOldReportYear && "Duration (YY-MM)",
        isOldReportYear && "Research / Consultancy",
        "PI or Co-PI",
        "Ongoing / Submitted",
        "Amount of Grant(Rs. in Lakhs)",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.sponsored_research_projects.forEach((sponsoredre) => {
      content.push(
        createTableRow([
          sponsoredre?.title,
          sponsoredre?.sponsored_agency,

          `${formatDate(sponsoredre.from_date)} - ${formatDate(
            sponsoredre.to_date
          )}`,
          isOldReportYear && sponsoredre?.duration,
          isOldReportYear && sponsoredre?.research_consultancy,
          sponsoredre?.pi_or_co_pi,
          sponsoredre?.ongoing_or_submitted,
          sponsoredre?.amount?.toString(),
          // sponsoredre?.attachment
          //   ? `<a href="${imagepath}${sponsoredre?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    ${isOldReportYear && `<td style="border: 1px solid black;"></td>`}
    ${isOldReportYear && `<td style="border: 1px solid black;"></td>`}
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;">Total Amount of Grant</td>
    <td style="border: 1px solid black;">${appliedReport?.total_amount_for_sponsored_research_projects}</td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
  </tr>
    `);
    content.push("</tbody></table>");
  }
  if (appliedReport?.consultancy_works_carried_out?.length > 0) {
    content.push("<h4>d. Consultancy works carried out based On the requirements of the clientele system :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Project Title/ Courses Conducted",
        "Sponsoring Agency",
        "Period",
        isOldReportYear && "Duration (YY-MM)",
        isOldReportYear && "Research / Consultancy",
        "PI or Co-PI",
        "Amount of Grant(Rs. in Lakhs)",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.consultancy_works_carried_out.forEach((consult) => {
      content.push(
        createTableRow([
          consult?.title,
          consult?.sponsored_agency,
          `${formatDate(consult.from_date)} - ${formatDate(consult.to_date)}`,
          isOldReportYear && consult?.duration,
          isOldReportYear && consult?.research_consultancy,
          consult?.pi_or_co_pi,
          consult?.amount?.toString(),
          // consult?.attachment
          //   ? `<a href="${imagepath}${consult?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    ${isOldReportYear && `<td style="border: 1px solid black;"></td>`}
    ${isOldReportYear && `<td style="border: 1px solid black;"></td>`}
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;">Total amount of grant</td>
    <td style="border: 1px solid black;">${appliedReport?.total_amount_for_consultancy_works_carried_out}</td>
  </tr>
    `);
    content.push("</tbody></table>");
  }
  if (appliedReport?.research_publications?.length > 0) {
    content.push(
      "<h4>e. Research Publications in referred journals only :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Author's (s) in order as appeared",
        "Title",
        "Name of Journal",
        "Volume No",
        "Volume Issue",
        "Year",
        "Listed",
        "Impact Factor",
        "Number of Citations as per Google Scholar",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.research_publications.forEach((researchpublic, index) => {
      content.push(
        createTableRow([
          researchpublic?.author_name,
          researchpublic?.title,
          researchpublic?.name_of_journal,
          researchpublic?.volume_no,
          researchpublic?.volume_issue,
          researchpublic?.year?.toString(),
          researchpublic?.sci_scopus_ugc,
          researchpublic?.impact_factor?.toString(),
          researchpublic?.no_of_citations,
          // researchpublic?.attachment
          //   ? `<a href="${imagepath}${researchpublic?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.papers_presentation?.length > 0) {
    content.push(
      "<h4>f. Papers presented in national / international conference/seminar :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Author's (s) in order as appeared",
        "Title",
        "Name of the Conference / Event",
        "ISSN Volume",
        "Page No",
        "Year",
        "Place",
        "Country",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.papers_presentation.forEach((paperpresent) => {
      content.push(
        createTableRow([
          paperpresent?.author_name,
          paperpresent?.title,
          paperpresent?.name_of_the_event,
          paperpresent?.issn_volume,
          paperpresent?.page_no,
          paperpresent?.year?.toString(),
          paperpresent?.place,
          paperpresent?.country,
          // paperpresent?.attachment
          //   ? `<a href="${imagepath}${paperpresent?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.books_authored?.length > 0) {
    content.push(
      "<h4>g. Books authored / Edited book / Edited proceedings / Book chapter / Monographs :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Author (s) Name in order as appeared",
        "Title",
        "Type of Publications",
        "ISBN / ISSN",
        "Publisher Country",
        "Publisher Year",
        "Total Pages",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.books_authored.forEach((books) => {
      content.push(
        createTableRow([
          books?.author_name,
          books?.title,
          books?.type_of_publications,
          books?.isbn_issn,
          books?.publisher_country,
          books?.publisher_year,
          books?.total_pages,
          // books?.attachment
          //   ? `<a href="${imagepath}${books?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.patents?.length > 0) {
    content.push(
      "<h4>h.Patents, copy right and technology transfer agreements signed :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title",
        "Type",
        "Registration No",
        "Registration Date",
        !isOldReportYear && "Level",
        "Granted / Published",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.patents.forEach((patent) => {
      content.push(
        createTableRow([
          patent?.title,
          patent?.type,
          patent?.registration_no,
          `${formatDate(patent.registration_date)}}`,
          !isOldReportYear && patent.level,
          patent?.granted_or_filed,
          // patent?.attachment
          //   ? `<a href="${imagepath}${patent?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.awards_details?.length > 0) {
    content.push(
      "<h4>i.Honors / awards / medals/ fellowships for outstanding contributions :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Name of the Awards / Medals / Fellowships",
        "Awarding Institution",
        "Area of Recognition",
        "National / International",
        "Year",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.awards_details.forEach((award) => {
      content.push(
        createTableRow([
          award?.name_of_the_award,
          award?.awarding_institution,
          award?.area_of_recognition,
          award?.national_or_international,
          award?.year,
          // award?.attachment
          //   ? `<a href="${imagepath}${award?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  {
    (appliedReport?.administrative_contributions?.length > 0 || appliedReport?.infrastructure_development?.length > 0 || appliedReport?.revenue_generated_through_training_program?.length > 0 || appliedReport?.research_or_academic_events?.length > 0 || appliedReport?.events_conducted?.length > 0 || appliedReport?.new_initiatives?.length > 0) &&
      content.push(`<p style="text-align:center; font-weight:bold;">INSTITUTIONAL DEVELOPMENT</p>`)
  }


  if (appliedReport?.administrative_contributions?.length > 0) {
    content.push("<h4>a. Administrative Contributions :</h4>");
    content.push(
      "<p> ((i) Head of Department / centre / Extension Centre; (ii) Chairman / Member of Internal Committees / Board of Studies / Academic Council / Academic Responsibilities; (iii) Warden / CVO / PIO / Nodal Officer / IQAC; <br /> (iv) In-charge of Maintenance - Civil / Electrical / Networking / Air-condition / Web site / Computer / Vehicle / Security) </p>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Position",
        isOldReportYear && "Duration",
        isOldReportYear && "Experience (YY-MM)",
        "Significant Contributions",
      ])
    );
    content.push("<tbody>");
    appliedReport?.administrative_contributions.forEach((admincontribute) => {
      content.push(
        createTableRow([
          admincontribute?.position,
          isOldReportYear && `${formatDate(admincontribute.from_date)} - ${formatDate(
            admincontribute.to_date
          )}`,
          isOldReportYear && admincontribute?.experience,
          admincontribute?.significant_contributions,
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.infrastructure_development?.length > 0) {
    content.push(
      "<h4>b. Infrastructure development with internal / external funding for improvement in science and technology :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Infrastructure Development",
        "Others",
        "Funding Agency",
        "Duration",
        "PI or Co-PI",
        "Salient Contributions",
        "Amount of Grant <br /> (Rs. in lakhs)",
      ])
    );
    content.push("<tbody>");
    appliedReport?.infrastructure_development.forEach((infra) => {
      content.push(
        createTableRow([
          infra?.type,
          infra?.others ? infra?.others : "NA",
          infra?.funding_agency,
          `${formatDate(infra.from_date)} - ${formatDate(infra.to_date)}`,
          infra?.pi_or_co_pi,
          infra?.salient_contributions,
          infra?.amount?.toString(),
        ])
      );
    });
    content.push(`
    <tr>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;"></td>
    <td style="border: 1px solid black;">Total amount of grant</td>
    <td style="border: 1px solid black;">${appliedReport?.total_amount_for_infrastructure_development}</td>
    <td style="border: 1px solid black;"></td>
  </tr>
    `);
    content.push("</tbody></table>");
  }
  if (isOldReportYear) {
    if (appliedReport?.revenue_generated_through_training_program?.length > 0) {
      content.push(
        "<h4>c. Revenue generated through Training Programmes as Co-ordinator / Other Avenues :</h4>"
      );
      content.push('<table style="border-collapse: collapse; width: 100%;">');
      content.push(
        createTableHeader([
          "Academic Event",
          "Title of Event",
          "National / International",
          "Role",
          "Amount (Rs. in lakhs)",
          // "Attachment",
        ])
      );
      content.push("<tbody>");
      appliedReport?.revenue_generated_through_training_program.forEach(
        (revenuegen) => {
          content.push(
            createTableRow([
              revenuegen?.academic_event,
              revenuegen?.title_of_event,
              revenuegen?.national_or_international,
              revenuegen?.role,
              revenuegen?.amount?.toString(),
              // revenuegen?.attachment
              //   ? `<a href="${imagepath}${revenuegen?.attachment}" target="_blank">View Document</a>`
              //   : "No Data",
            ])
          );
        }
      );
      content.push("</tbody></table>");
    }
  }
  if (appliedReport?.research_or_academic_events?.length > 0) {
    content.push(
      `<h4>${isOldReportYear ? 'd. ' : 'c. '} Research / academic events (workshop / conference / seminar / webinar / programmes under national initiatives) organized at national / international level :</h4>`
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Academic Event",
        "Title of Event",
        "Date",
        "Role",
        "No.of Participants",
        "National / International",
      ])
    );
    content.push("<tbody>");
    appliedReport?.research_or_academic_events.forEach((reaearchevent) => {
      content.push(
        createTableRow([
          reaearchevent?.academic_event,
          reaearchevent?.title_of_event,
          `${formatDate(reaearchevent.from_date)}`,
          reaearchevent?.role,
          reaearchevent?.no_of_participants?.toString(),
          reaearchevent?.national_or_international,
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.events_conducted?.length > 0) {
    content.push(
      `<h4>${isOldReportYear ? 'e. ' : 'd. '}Events conducted in collaboration with Industry :</h4>`
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of Event",
        "Date",
        "Role",
        "No.of Participants",
        "Name of the Industry",
        "Revenue Generated (if applicable)",
      ])
    );
    content.push("<tbody>");
    appliedReport?.events_conducted.forEach((eventconduct) => {
      content.push(
        createTableRow([
          eventconduct?.title_of_event,
          `${formatDate(eventconduct.from_date)}`,
          eventconduct?.role,
          eventconduct?.no_of_participants?.toString(),
          eventconduct?.name_of_the_industry,
          eventconduct?.revenue_generated?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.new_initiatives?.length > 0) {
    content.push(
      `<h4>${isOldReportYear ? 'f. ' : 'e. '}New initiatives implemented for the Institute Development :</h4>`
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Initiative Implemented",
        "Type of Benefit to the Institute",
        "Revenue Generated (if applicable)",
        "Role",
      ])
    );
    content.push("<tbody>");
    appliedReport?.new_initiatives.forEach((newinit) => {
      content.push(
        createTableRow([
          newinit?.initiative_implemented,
          newinit?.type_of_benefit,
          newinit?.revenue_generated?.toString(),
          newinit?.role,
        ])
      );
    });
    content.push("</tbody></table>");
  }

  {
    (appliedReport?.resource_person_in_training_programmes?.length > 0 || appliedReport?.training_programmes_attended?.length > 0 || appliedReport?.participation_and_academic_contributions?.length > 0 || appliedReport?.overseas_visited_for_academic_events?.length > 0 || appliedReport?.participation_and_contributions?.length > 0 || appliedReport?.editor_in_chief?.length > 0 || appliedReport?.national_or_internatioal_assignment?.length > 0 || appliedReport?.fellow_or_life_member?.length > 0) &&
      content.push(`<p style="text-align:center; font-weight:bold;">PROFESSIONAL CONTRIBUTIONS</p>`)
  }

  if (appliedReport?.resource_person_in_training_programmes?.length > 0) {
    content.push(
      "<h4>a. Resource person in Training Programmes / Workshops (External) :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of the Program",
        "Mode",
        "Conducted at",
        "Duration",
        "No.of Hours Handled",
        "Level",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.resource_person_in_training_programmes.forEach(
      (resourceperson) => {
        content.push(
          createTableRow([
            resourceperson?.title,
            resourceperson?.mode,
            resourceperson?.conducted_at,
            `${formatDate(resourceperson.from_date)} - ${formatDate(
              resourceperson.to_date
            )}`,
            resourceperson?.no_of_hours?.toString(),
            resourceperson?.level,
            // resourceperson?.attachment
            //   ? `<a href="${imagepath}${resourceperson?.attachment}" target="_blank">View Document</a>`
            //   : "No Data",
          ])
        );
      }
    );
    content.push(`
                <tr>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;">Total numbers of hours handled</td>
                  <td style="border: 1px solid black;">${appliedReport?.total_no_of_hours_for_resource_person_in_training_programmes}</td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                  <td style="border: 1px solid black;"></td>
                </tr>
    `);
    content.push("</tbody></table>");
  }
  if (appliedReport?.training_programmes_attended?.length > 0) {
    content.push("<h4>b. Training programmes attended :</h4>");
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Title of the Training",
        "Host Institution",
        "Sponsoring Agency",
        "Duration",
        "Level",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.training_programmes_attended.forEach((training) => {
      content.push(
        createTableRow([
          training?.title,
          training?.host_institution,
          training?.sponsoring_agency,
          `${formatDate(training.from_date)} - ${formatDate(
            training.to_date
          )}`,
          training?.national_or_international,
          // training?.attachment
          //   ? `<a href="${imagepath}${training?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.participation_and_academic_contributions?.length > 0) {
    content.push(
      "<h4>c. Participation and academic contributions in the area of your professional expertise at <br />State / National/ International Level :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Assignment",
        "Organization",
        "Nature of Duty",
        "Duration",
        isOldReportYear && "Experience (YY-MM)",
        "Level",
      ])
    );
    content.push("<tbody>");
    appliedReport?.participation_and_academic_contributions.forEach(
      (participat) => {
        content.push(
          createTableRow([
            participat?.assignment,
            participat?.organization,
            participat?.nature_of_duty,
            `${formatDate(participat.from_date)} - ${formatDate(
              participat.to_date
            )}`,
            isOldReportYear && participat?.experience,
            participat?.level,
          ])
        );
      }
    );
    content.push("</tbody></table>");
  }
  if (appliedReport?.overseas_visited_for_academic_events?.length > 0) {
    content.push(
      "<h4>d. Overseas visited for Academic Events / Plenary Lectures / Invited Talks / part of Delegation / Others :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Organization / University Visited",
        "City Visited",
        "Country Visited",
        "Institution Sponsored the visit",
        "Nature of Visit",
        "Duration From Date",
        "Duration To Date",
        isOldReportYear && "Duration Duration",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.overseas_visited_for_academic_events.forEach(
      (overseas) => {
        content.push(
          createTableRow([
            overseas?.organization_or_university,
            overseas?.city,
            overseas?.country,
            overseas?.institution_sponsored,
            overseas?.nature_of_visit,
            `${formatDate(overseas.from_date)}`,
            `${formatDate(overseas.to_date)}`,
            isOldReportYear && overseas.duration,
            // overseas?.attachment
            //   ? `<a href="${imagepath}${overseas?.attachment}" target="_blank">View Document</a>`
            //   : "No Data",
          ])
        );
      }
    );
    content.push("</tbody></table>");
  }
  if (appliedReport?.participation_and_contributions?.length > 0) {
    content.push(
      "<h4>e. Participation and contributions in the area of your academic and professional expertise :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Details",
        "Period From Date",
        "Period To Date",
        isOldReportYear && "Period Duration",
        // "Attachment",
      ])
    );
    content.push("<tbody>");
    appliedReport?.participation_and_contributions.forEach((parti) => {
      content.push(
        createTableRow([
          parti?.details,
          `${formatDate(parti?.from_date)}`,
          `${formatDate(parti?.to_date)}`,
          isOldReportYear && parti.duration,
          // parti?.attachment
          //   ? `<a href="${imagepath}${parti?.attachment}" target="_blank">View Document</a>`
          //   : "No Data",
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.editor_in_chief?.length > 0) {
    content.push(
      "<h4>f. Editor-in-chief / Editorial Board Member / Peer Reviewer / Others :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Role",
        "Title of Journal",
        "Journal Publisher",
        "ISSN",
        "Period (Year)",
      ])
    );
    content.push("<tbody>");
    appliedReport?.editor_in_chief.forEach((edit) => {
      content.push(
        createTableRow([
          edit?.role,
          edit?.title_of_journal,
          edit?.journal_publisher,
          edit?.issn,
          edit?.year?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }
  if (appliedReport?.national_or_internatioal_assignment?.length > 0) {
    content.push(
      "<h4>g. National / International academic assignment for more than 1 year (Full-time) :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Post / Assignment",
        "National / International Organization / University",
        "Nature of Assignment",
        "Duration From Date",
        "Duration To Date",
        "Duration",
      ])
    );
    content.push("<tbody>");
    appliedReport?.national_or_internatioal_assignment.forEach(
      (nationalassign) => {
        content.push(
          createTableRow([
            nationalassign?.type,
            nationalassign?.level,
            nationalassign?.nature_of_assignment,
            `${formatDate(nationalassign?.from_date)}`,
            `${formatDate(nationalassign?.to_date)}`,
            nationalassign.duration,
          ])
        );
      }
    );
    content.push("</tbody></table>");
  }
  if (appliedReport?.fellow_or_life_member?.length > 0) {
    content.push(
      "<h4>h. Fellow / Life Member / Member of Professional Bodies / Societies :</h4>"
    );
    content.push('<table style="border-collapse: collapse; width: 100%;">');
    content.push(
      createTableHeader([
        "Name of the Professional Bodies / Societies",
        "Fellow / Life Member / Member",
        "National / International",
        "Registration No",
        "Registration Year",
      ])
    );
    content.push("<tbody>");
    appliedReport?.fellow_or_life_member.forEach((fellow) => {
      content.push(
        createTableRow([
          fellow?.name,
          fellow?.type,
          fellow?.level,
          fellow?.registration_no,
          fellow?.registration_year?.toString(),
        ])
      );
    });
    content.push("</tbody></table>");
  }

  const htmlContent = content.join("");

  const blob = htmlDocx.asBlob(htmlContent);
  saveAs(blob, "Appraisal Report.docx");
};